module.exports = __webpack_public_path__ + "static/media/03n.e0e1951b.svg";